import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import moment from 'moment';
import getLocale from '../../i18n/getLocale';

class AvailabilitiesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      contract_id: null,
      contract_name: null,
      base_id: null,
      aircraft_id: null,
      interruption_start: null,
      interruption_finish: null,
      deadline_preview: null,
      deadline_preview_delay: null,
      type: null,
      abnormal_ocurrence: 0,
      reason: null,
      contracts_select: [],
      bases_select: [],
      aircrafts_select: [],
      types_select: [],
      availability_approvals: {},
      availability_backups: {},
      errors_messages: [],
      errors_listing: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleChangeWithDelayCalc = this.handleChangeWithDelayCalc.bind(this);

    this.locale = getLocale();

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
    this.finalize = this.finalize.bind(this);
    this.approve = this.approve.bind(this);
    this.repprove = this.repprove.bind(this);
    this.addBackup = this.addBackup.bind(this);
    this.deleteBackup = this.deleteBackup.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleChangeWithDelayCalc(name, event) {
    var change = {};

    change[name] = event.target.value;

    if(this.state.deadline_preview && this.state.interruption_finish) {

      let deadline_preview = this.state.deadline_preview;
      let interruption_finish = this.state.interruption_finish;

      if (name === 'deadline_preview') {
        deadline_preview = event.target.value;
      } else {
        interruption_finish = event.target.value;
      }
      if(deadline_preview.length === 16 && interruption_finish.length === 16) {
        deadline_preview = moment(deadline_preview, "DD/MM/YYYY HH:mm:ss");
        interruption_finish = moment(interruption_finish, "DD/MM/YYYY HH:mm:ss");

        deadline_preview = new Date(deadline_preview.format("YYYY-MM-DD HH:mm:ss"));
        interruption_finish = new Date(interruption_finish.format("YYYY-MM-DD HH:mm:ss"));
        let diffTime = Math.abs(deadline_preview.getTime() - interruption_finish.getTime());
        if (interruption_finish > deadline_preview) {
          change['deadline_preview_delay_str'] = this.calcTimeFromMs(diffTime);
        } else {
          change['deadline_preview_delay_str'] = '00:00';
        }
      } else {
        change['deadline_preview_delay_str'] = '00:00';
      }
    } else {
      change['deadline_preview_delay_str'] = '00:00';
    }
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  calcTimeFromMs(diffTime) {
    diffTime = diffTime/1000;
    var secs = diffTime % 60;
    diffTime = (diffTime - secs) / 60;
    var mins = diffTime % 60;
    var hrs = (diffTime - mins) / 60;
    if (secs < 10) { secs = '0' + secs; }
    if (mins < 10) { mins = '0' + mins; }
    if (hrs < 10) { hrs = '0' + hrs; }
    return hrs + ':' + mins + ':' + secs ;
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/indisponibilidade/info/edicao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/indisponibilidades');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            contract_id: responseJson.data.main.contract_id,
            contract_name: responseJson.data.main.contract_name,
            base_id: responseJson.data.main.base_id,
            aircraft_id: responseJson.data.main.aircraft_id,
            interruption_start: responseJson.data.main.interruption_start_str,
            interruption_finish: responseJson.data.main.interruption_finish_str,
            deadline_preview: responseJson.data.main.deadline_preview_str,
            deadline_preview_delay: responseJson.data.main.deadline_preview_delay,
            deadline_preview_delay_str: responseJson.data.main.deadline_preview_delay_str,
            abnormal_ocurrence: responseJson.data.main.abnormal_ocurrence,
            reason: responseJson.data.main.reason,
            type: responseJson.data.main.type,
            status_str: responseJson.data.main.status_str,
            status: responseJson.data.main.status,
            total: responseJson.data.main.total,
            total_str: responseJson.data.main.total_str,
            total_spare: responseJson.data.main.total_spare,
            total_spare_str: responseJson.data.main.total_spare_str,
            total_full: responseJson.data.main.total_full,
            total_full_str: responseJson.data.main.total_full_str,
            availability_start: responseJson.data.main.availability_start,
            availability_finish: responseJson.data.main.availability_finish,
            availability: responseJson.data.main.availability,
            spare_time: responseJson.data.main.spare_time,
          });
          self.setState({ availability_backups: responseJson.data.availability_backups });
          self.setState({ availability_approvals: responseJson.data.availability_approvals });
          self.setState({ contracts_select: responseJson.data.contracts_select });
          self.setState({ bases_select: responseJson.data.bases_select });
          self.setState({ aircrafts_select: responseJson.data.aircrafts_select });
          self.setState({ types_select: responseJson.data.types_select });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  finalize(availability_approval_id) {
    var self = this;
    if(window.confirm(this.locale.Indisponibilidades.EditarIndisponibilidade.finalizarFicha)) {
      self.handleAlert('', '', 'open');
      var datasave = {
        availability_approval_id: availability_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/indisponibilidade/aprovacoes/finalizar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              id: responseJson.data.main.id,
              contract_id: responseJson.data.main.contract_id,
              contract_name: responseJson.data.main.contract_name,
              base_id: responseJson.data.main.base_id,
              aircraft_id: responseJson.data.main.aircraft_id,
              interruption_start: responseJson.data.main.interruption_start_str,
              interruption_finish: responseJson.data.main.interruption_finish_str,
              deadline_preview: responseJson.data.main.deadline_preview_str,
              deadline_preview_delay: responseJson.data.main.deadline_preview_delay,
              deadline_preview_delay_str: responseJson.data.main.deadline_preview_delay_str,
              abnormal_ocurrence: responseJson.data.main.abnormal_ocurrence,
              reason: responseJson.data.main.reason,
              type: responseJson.data.main.type,
              status_str: responseJson.data.main.status_str,
              status: responseJson.data.main.status,
              total: responseJson.data.main.total,
              total_str: responseJson.data.main.total_str,
              total_spare: responseJson.data.main.total_spare,
              total_spare_str: responseJson.data.main.total_spare_str,
              total_full: responseJson.data.main.total_full,
              total_full_str: responseJson.data.main.total_full_str,
              availability_start: responseJson.data.main.availability_start,
              availability_finish: responseJson.data.main.availability_finish,
              availability: responseJson.data.main.availability,
              spare_time: responseJson.data.main.spare_time,
            });
            self.setState({ availability_approvals: responseJson.data.availability_approvals });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approve(availability_approval_id) {
    var self = this;
    if(window.confirm(this.locale.Indisponibilidades.EditarIndisponibilidade.finalizarFicha)) {
      self.handleAlert('', '', 'open');
      var datasave = {
        availability_approval_id: availability_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/indisponibilidade/aprovacoes/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              id: responseJson.data.main.id,
              contract_id: responseJson.data.main.contract_id,
              contract_name: responseJson.data.main.contract_name,
              base_id: responseJson.data.main.base_id,
              aircraft_id: responseJson.data.main.aircraft_id,
              interruption_start: responseJson.data.main.interruption_start_str,
              interruption_finish: responseJson.data.main.interruption_finish_str,
              deadline_preview: responseJson.data.main.deadline_preview_str,
              deadline_preview_delay: responseJson.data.main.deadline_preview_delay,
              deadline_preview_delay_str: responseJson.data.main.deadline_preview_delay_str,
              abnormal_ocurrence: responseJson.data.main.abnormal_ocurrence,
              reason: responseJson.data.main.reason,
              type: responseJson.data.main.type,
              status_str: responseJson.data.main.status_str,
              status: responseJson.data.main.status,
              total: responseJson.data.main.total,
              total: responseJson.data.main.total,
              total_str: responseJson.data.main.total_str,
              total_spare: responseJson.data.main.total_spare,
              total_spare_str: responseJson.data.main.total_spare_str,
              total_full: responseJson.data.main.total_full,
              total_full_str: responseJson.data.main.total_full_str,
              availability_start: responseJson.data.main.availability_start,
              availability_finish: responseJson.data.main.availability_finish,
              availability: responseJson.data.main.availability,
              spare_time: responseJson.data.main.spare_time,
            });
            self.setState({ availability_approvals: responseJson.data.availability_approvals });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  repprove(event) {
    var self = this;
    if(window.confirm(this.locale.Indisponibilidades.EditarIndisponibilidade.reprovarFicha)) {
      event.preventDefault();
      self.handleAlert('', '', 'open');
      var datasave = {
        availability_approval_id: self.state.table_id,
        justification: self.state.justification,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/indisponibilidade/aprovacoes/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              id: responseJson.data.main.id,
              contract_id: responseJson.data.main.contract_id,
              contract_name: responseJson.data.main.contract_name,
              base_id: responseJson.data.main.base_id,
              aircraft_id: responseJson.data.main.aircraft_id,
              interruption_start: responseJson.data.main.interruption_start_str,
              deadline_preview: responseJson.data.main.deadline_preview_str,
              deadline_preview_delay: responseJson.data.main.deadline_preview_delay,
              deadline_preview_delay_str: responseJson.data.main.deadline_preview_delay_str,
              abnormal_ocurrence: responseJson.data.main.abnormal_ocurrence,
              reason: responseJson.data.main.reason,
              type: responseJson.data.main.type,
              status_str: responseJson.data.main.status_str,
              status: responseJson.data.main.status,
              total: responseJson.data.main.total,
              total_str: responseJson.data.main.total_str,
              total_spare: responseJson.data.main.total_spare,
              total_spare_str: responseJson.data.main.total_spare_str,
              total_full: responseJson.data.main.total_full,
              total_full_str: responseJson.data.main.total_full_str,
              availability_start: responseJson.data.main.availability_start,
              availability_finish: responseJson.data.main.availability_finish,
              availability: responseJson.data.main.availability,
              spare_time: responseJson.data.main.spare_time,
              interruption_finish: '',
              availability_approvals: responseJson.data.availability_approvals,
              modal: false,
              justification: null,
            });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      contract_id: this.state.contract_id,
      base_id: this.state.base_id,
      aircraft_id: this.state.aircraft_id,
      interruption_start: this.state.interruption_start,
      interruption_finish: this.state.interruption_finish,
      deadline_preview: this.state.deadline_preview,
      deadline_preview_delay: this.state.deadline_preview_delay_str,
      abnormal_ocurrence: this.state.abnormal_ocurrence,
      reason: this.state.reason,
      type: this.state.type,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/indisponibilidade', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({
            total: responseJson.data.main.total,
            total_str: responseJson.data.main.total_str,
            total_spare: responseJson.data.main.total_spare,
            total_spare_str: responseJson.data.main.total_spare_str,
            total_full: responseJson.data.main.total_full,
            total_full_str: responseJson.data.main.total_full_str,
            status: responseJson.data.main.status,
            status_str: responseJson.data.main.status_str,
            availability_start: responseJson.data.main.availability_start,
            availability_finish: responseJson.data.main.availability_finish,
            availability: responseJson.data.main.availability,
            spare_time: responseJson.data.main.spare_time,
            availability_approvals: responseJson.data.availability_approvals,
          });
        } else if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: true,
            errors_messages: responseJson.data,
          });
        } else {
          self.setState({
            errors_listing: false,
            errors_messages: [],
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addBackup(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      availability_id: this.state.id,
      aircraft_id: this.state.backup_aircraft_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/indisponibilidade/backup', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if(responseJson.status === 'success') {
          self.setState({availability_backups: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  // Deletar backup
  deleteBackup(id) {
    if (window.confirm(this.locale.Indisponibilidades.EditarIndisponibilidade.deletarBackup)) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/indisponibilidade/backup/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          if(responseJson.status === 'success') {
            self.setState({availability_backups: responseJson.data});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  showModal (value, event) {
    this.setState({ table_id: value, modal: true});
  }

  render() {
    var self = this;
    let status_label = 'danger';
    if (this.state.status_str === 'Finalizado') {
      status_label = 'success'
    }
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Indisponibilidades.EditarIndisponibilidade.titulo} <small><span className={"label label-sm label-" + status_label}>{this.state.status_str}</span></small></h3>
      <Link to="/indisponibilidades" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Indisponibilidades.EditarIndisponibilidade.erros}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.Contrato}:</label>
              <input value={this.state.contract_name} name="contract_name" className="form-control" onChange={this.handleChange.bind(this, 'contract_name')} placeholder="" disabled />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.InicioInterrupcao}:</label>
              <InputMask value={this.state.interruption_start} disabled={(this.state.status !== 'draft') ? 'disabled' : ''} name="interruption_start" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'interruption_start')} placeholder={this.locale.general.diaMesAnoHoraMinuto} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.Base}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_select}
                required
                disabled={(this.state.status !== 'draft') ? 'disabled' : ''}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.types_select}
                required
                disabled={(this.state.status !== 'draft') ? 'disabled' : ''}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.HoraInicialContratual}:</label>
              <input value={this.state.availability_start} name="availability_start" className="form-control" onChange={this.handleChange.bind(this, 'availability_start')} placeholder="" disabled />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.HoraTerminoContratual}:</label>
              <input value={this.state.availability_finish} name="availability_finish" className="form-control" onChange={this.handleChange.bind(this, 'availability_finish')} placeholder="" disabled />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.TempoDisponibilidadeContratual}:</label>
              <input value={this.state.availability} name="availability" className="form-control" onChange={this.handleChange.bind(this, 'availability')} placeholder="" disabled />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.Franquia}:</label>
              <input value={this.state.spare_time} name="spare_time" className="form-control" onChange={this.handleChange.bind(this, 'spare_time')} placeholder="" disabled />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.OcorrenciaAnormal}:</label>
              <Select
                className="form-field-name"
                name="abnormal_ocurrence"
                value={this.state.abnormal_ocurrence}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'abnormal_ocurrence')}
                options={[
                  {value: 0, label: this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.opcoesOcorrenciaAnormal.Nao},
                  {value: 1, label: this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.opcoesOcorrenciaAnormal.Sim},
                ]}
                required
                disabled={(this.state.status !== 'draft') ? 'disabled' : ''}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.Razao}:</label>
              <input value={this.state.reason} disabled={(this.state.status !== 'draft') ? 'disabled' : ''} name="reason" className="form-control" onChange={this.handleChange.bind(this, 'reason')} placeholder="" required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.PrevisaoRetorno}:</label>
              <InputMask value={this.state.deadline_preview} disabled={(this.state.status !== 'draft') ? 'disabled' : ''} name="deadline_preview" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'deadline_preview')} onBlur={this.handleChangeWithDelayCalc.bind(this, 'deadline_preview')} placeholder={this.locale.general.diaMesAnoHoraMinuto} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.FimInterrupcao}:</label>
              <InputMask value={this.state.interruption_finish} disabled={(this.state.status !== 'draft') ? 'disabled' : ''} name="interruption_finish" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'interruption_finish')} onBlur={this.handleChangeWithDelayCalc.bind(this, 'interruption_finish')} placeholder={this.locale.general.diaMesAnoHoraMinuto} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.formulario.DiferencaPrevisaoRetorno}:</label>
              <InputMask value={this.state.deadline_preview_delay_str} disabled={(this.state.status !== 'draft') ? 'disabled' : ''} name="deadline_preview_delay" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'deadline_preview_delay')} placeholder={this.locale.general.horaMinuto} />
            </div>
          </div>
        </div>
        <hr />
        <div className="form-group">
          <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={(this.state.status !== 'draft') ? 'disabled' : ''}><i className="fa fa-fw fa-save"></i> Editar indisponibilidade</button>
        </div>
      </form>
      <hr/>
      <h4>{this.locale.Indisponibilidades.EditarIndisponibilidade.backup.titulo}</h4>
      <hr/>
      <form onSubmit={this.addBackup}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.backup.formulario.AeronaveBackup}:</label>
              <Select
                className="form-field-name"
                name="backup_aircraft_id"
                value={this.state.backup_aircraft_id}
                searchable={true}
                placeholder={this.locale.Indisponibilidades.EditarIndisponibilidade.backup.formulario.placeholder.SelecionarAeronaveDeBackup}
                onChange={this.handleSelectChange.bind(this, 'backup_aircraft_id')}
                options={this.state.aircrafts_select}
                required
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.backup.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start}  name="date_start" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder={this.locale.general.diaMesAnoHoraMinuto} required />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.EditarIndisponibilidade.backup.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish}  name="date_finish" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder={this.locale.general.diaMesAnoHoraMinuto} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Indisponibilidades.EditarIndisponibilidade.backup.formulario.botaoSalvarBackup}</button>
          </div>
        </div>
      </form>
      <hr/>
      <h4>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaBackup.titulo}</h4>
      <hr/>
      <table className="table">
        <thead>
          <tr>
            <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaBackup.aeronave}</th>
            <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaBackup.dataInicial}</th>
            <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaBackup.dataFinal}</th>
            <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaBackup.acoes}</th>
          </tr>
        </thead>
        <tbody id="frotas">
          {Object.keys(self.state.availability_backups).map(function(k) {
            return (
              <tr>
                <td>{self.state.availability_backups[k].aircraft.registration}</td>
                <td>{self.state.availability_backups[k].date_start_str}</td>
                <td>{self.state.availability_backups[k].date_finish_str}</td>
                <td>
                  <button className="btn btn-sm btn-danger" onClick={() => self.deleteBackup(self.state.availability_backups[k].id)}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <hr/>
      <h4>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.titulo}</h4>
      <hr/>
      <div className="listing table-responsive">
        <table className="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th className="text-center">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.inicioDisponibilidade}</th>
              <th className="text-center">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.fimDisponibilidade}</th>
              <th className="text-center">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.disponibilidade}</th>
              <th className="text-center">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.franquia}</th>
              <th className="text-center">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.indisponibilidadeContratual}</th>
              <th className="text-center">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.indisponibilidadeContratualSemFranquia}</th>
              <th className="text-center">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaTotais.indisponibilidadeReal}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">{this.state.availability_start}</td>
              <td className="text-center">{this.state.availability_finish}</td>
              <td className="text-center">{this.state.availability}</td>
              <td className="text-center">{this.state.spare_time}</td>
              <td className="text-center" style={{fontWeight: 'bold', color: ''}}>{this.state.total_str}</td>
              <td className="text-center" style={{fontWeight: 'bold', color: ''}}>{this.state.total_spare_str}</td>
              <td className="text-center" style={{fontWeight: 'bold', color: ''}}>{this.state.total_full_str}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.titulo}</h3>
      <hr/>
      <div className="listing table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead>
            <tr>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.ID}</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.tipo}</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.interrompido}</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.finalizado}</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.aprovado}</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.interrompidoPor}:</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.finalizadoPor}:</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.aprovadoPor}:</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.justificativa}</th>
              <th>{this.locale.Indisponibilidades.EditarIndisponibilidade.tabelaAprovacoes.acoes}</th>
            </tr>
          </thead>
          <tbody>
          {self.state.availability_approvals && Object.keys(self.state.availability_approvals).map(function(k) {
            var sra = self.state.availability_approvals[k];
            return (
              <tr>
                <td>{sra.id}</td>
                <td>{sra.type_str}</td>
                <td>{sra.finalize_pending_date}</td>
                <td>{sra.finalized_date}</td>
                <td>{sra.approval_date}</td>
                <td>{sra.finalize_pending_staff}</td>
                <td>{sra.finalized_staff}</td>
                <td>{sra.approval_staff}</td>
                <td>{sra.justification}</td>
                <td className="text-center" width='80'>
                  {
                    (sra.type === 'finalize_pending') ?
                    <div>
                      <button onClick={() => {self.finalize(sra.id)}} className="btn btn-success btn-sm"><i className="fa fa-check"></i></button>
                      <button onClick={self.showModal.bind(self, sra.id)} className="btn btn-danger btn-sm"><i className="fa fa-close"></i></button>
                    </div>
                    :
                      ''
                  }
                  {
                    (sra.type === 'approval') ?
                    <div>
                      <button onClick={() => {self.approve(sra.id)}} className="btn btn-success btn-sm"><i className="fa fa-check"></i></button>
                      <button onClick={self.showModal.bind(self, sra.id)} className="btn btn-danger btn-sm"><i className="fa fa-close"></i></button>
                    </div>
                    :
                      ''
                  }
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">{this.locale.Indisponibilidades.EditarIndisponibilidade.modalJustificativa.titulo}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, justification: null, table_id: null })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.repprove}>
            <div className="form-group">
              <textarea style={{ height: 100 }} type="text" name="justification" className="form-control" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} required />
            </div>
            <div className="form-group">
              <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Indisponibilidades.EditarIndisponibilidade.modalJustificativa.formulario.Justificar}</button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, justification: null, table_id: null })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default AvailabilitiesEdit;



// WEBPACK FOOTER //
// ./src/Components/Availabilities/AvailabilitiesEdit.js